import React, {createContext, useState} from 'react';

export const DriversAndVehiclesDataReportContext = createContext({
  selectedDrivers: [],
  dataPrefillDrivers: [],
  selectedRisks:[],
  dataPrefillRisks: [],
  expandDrivers: true,
  expandRisks: true,
  setDataPrefillDrivers:() => ({}),
  setSelectedDrivers:() => ({}),
  setSelectedRisks:() => ({}),
  setDataPrefillRisks:() => ({}),
  setExpandDrivers:() => ({}),
  setExpandRisks:() => ({}),
});

const DriversAndVehiclesDataReportProvider = ({ children }) => {
  const [dataPrefillDrivers, setDataPrefillDrivers] = useState([]);
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [selectedRisks, setSelectedRisks] = useState([]);
  const [dataPrefillRisks, setDataPrefillRisks] = useState([]);
  const [expandDrivers, setExpandDrivers] = useState(true);
  const [expandRisks, setExpandRisks] = useState(true);


  return (
    <DriversAndVehiclesDataReportContext.Provider
      value={{
        selectedDrivers,
        dataPrefillDrivers,
        selectedRisks,
        dataPrefillRisks,
        expandDrivers,
        expandRisks,
        setSelectedDrivers,
        setDataPrefillDrivers,
        setSelectedRisks,
        setDataPrefillRisks,
        setExpandDrivers,
        setExpandRisks,
      }}
    >
      {children}
    </DriversAndVehiclesDataReportContext.Provider>
  );
};

export default DriversAndVehiclesDataReportProvider;
